
import { createStore, combineReducers, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// Reducers imported
import { authReducer } from "./auth/reducers";
import { userReducer } from "./users/reducers";
import { profileReducer } from "./profile/reducers";
import { playlistReducer } from "./playList/reducers";
import { followReducer } from "./follow/reducers";
import { mediaReducer } from "./media/reducers";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  profile: profileReducer,
  playlist: playlistReducer,
  follow: followReducer,
  media: mediaReducer
});

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);
  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );
  return store;
}
